export const parseEvent = event => ({
	...event,
	homescreen_layout: JSON.parse(event.homescreen_layout || '{}'),
	side_navigation: JSON.parse(event.side_navigation || '{}'),
	custom_metadata_fields: JSON.parse(event.custom_metadata_fields || '[]'),
	theme: JSON.parse(event.theme || '{}'),
	homescreen_theme: JSON.parse(event.homescreen_theme || '{}'),
});

export const normalizeEvent = event => {
	return {
		...event,
		homescreen_layout: JSON.stringify(event.homescreen_layout || {}),
		side_navigation: JSON.stringify(event.side_navigation || {}),
		custom_metadata_fields: JSON.stringify(event.custom_metadata_fields),
		theme: JSON.stringify(event.theme || {}),
		homescreen_theme: JSON.stringify(event.homescreen_theme || {}),
	};
};
